import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { PageHeader, Button } from '@/components/shared/ui';

const KHA_MEMBER_STATUS_KEY = 'kha_member_status';

export default function KhaVerify(): React.ReactElement {
    const { t } = useTranslation('auth');
    const navigate = useNavigate();
    const location = useLocation();
    const returnTo = (location.state as { returnTo?: string })?.returnTo ?? '/master/cart';

    const handleVerifyFullMember = () => {
        localStorage.setItem(KHA_MEMBER_STATUS_KEY, 'full');
        navigate(returnTo);
    };

    const handleVerifyNonFullMember = () => {
        localStorage.setItem(KHA_MEMBER_STATUS_KEY, 'verified');
        navigate(returnTo);
    };

    return (
        <div className="min-h-screen">
            <PageHeader
                title={t('khaVerify.pageTitle')}
                breadcrumbs={[
                    { label: t('khaVerify.breadcrumbCart'), link: returnTo },
                    { label: t('khaVerify.pageTitle') }
                ]}
            />
            <div className="max-w-xl mx-auto px-4 py-8">
                <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6 space-y-6">
                    <p className="text-gray-700">
                        {t('khaVerify.description')}
                    </p>
                    <p className="text-sm text-gray-500">
                        {t('khaVerify.note')}
                    </p>
                    <div className="flex flex-col gap-2 pt-4">
                        <Button variant="primary" size="lg" className="w-full" onClick={handleVerifyFullMember}>
                            {t('khaVerify.fullMember')}
                        </Button>
                        <Button variant="outline" size="lg" className="w-full" onClick={handleVerifyNonFullMember}>
                            {t('khaVerify.nonFullMember')}
                        </Button>
                        <Button variant="ghost" size="lg" className="w-full" onClick={() => navigate(returnTo)}>
                            {t('khaVerify.cancel')}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
}
